
import React from 'react'
const json = {
    patient_id: '',
    img_path : '',
    detail : '',
    img_path_preview : '',
    admission_id  : '',
    active:false
}
export default json;
